/**
 * Header trạng thái kiểm tra
 */
export default {
  /**
   * Tổng số
   */
  Total: 0,
  /**
   * Chưa nộp
   */
  NotSubmit: 5,
  /**
   * Cần kiểm tra
   */
  NotExamine: 10,
  /**
   * Đã gửi trả
   */
  Return: 15,
  /**
   * Đã hoàn thành
   */
  Complete: 20,
};
